import { Field, FormikProvider, FormikValues, useFormik } from "formik";
import Input from "../../../../customs/FormInput";
import Select from "../../../../customs/SelectInput";
import CustomButton from "../../../../customs/Button";
import {styled} from '@mui/material'


interface EmailTemplateCreateProps {
    cancel: (parmeter: boolean) => void;
}

const EmailTemplateCreate = ({cancel}: EmailTemplateCreateProps) => {
    const formik = useFormik<FormikValues>({
          initialValues: {
  
          },
          onSubmit: () => {
  
          }
      })
    return(
      <EmailTemplateCreateContainer>
          <FormikProvider value={formik}>
              <form>
                  <FormWrapper>
                    <SubWrapper>
                      <Field 
                          name='templateCode'
                          type='text'
                          as={Input}
                          label='Template Code'
                      />
                      <Field 
                          name='route'
                          type='text'
                          as={Select}
                          label='Route'
                      />
                    </SubWrapper>
                      <Field 
                          name='templateName'
                          type='text'
                          as={Input}
                          label='Target Name'
                      />
                      <Field 
                          name='titleSubject'
                          type='text'
                          as={Input}
                          label='Title / Subject'
                      />
                      <Field 
                          name='message'
                          type='text'
                          as={Input}
                          label='Message'
                          placeholder='Message'
                      />
                  </FormWrapper>
                  <ButtonWrapper>
                      <ButtonContainer>
                          <span onClick={() => cancel(false)}> Cancel</span>
                          <StyledButton type="submit" text='Submit'/>
                      </ButtonContainer>
                  </ButtonWrapper>
              </form>
          </FormikProvider>
      </EmailTemplateCreateContainer>
    )
  }


  export default EmailTemplateCreate;
  
  const EmailTemplateCreateContainer = styled('div')`
    margin-inline: 3.5rem;
  `
  const FormWrapper = styled('div')`
     
  `
  
  const ButtonWrapper = styled('div')`
      display: flex;
      justify-content: flex-end;
      margin-block: 2.5rem;

      & span {
        cursor: pointer;
      }
  `
  
  const ButtonContainer = styled('div')`
      display: flex;
      gap: 2rem;
      align-items: center;
  `
  
  const StyledButton = styled(CustomButton)`
      padding-block: 1rem;
      padding-inline: 2rem;
  `
  const SubWrapper = styled('div')`
    display: flex;
    gap: 40px;
  `